<template>
  <div>
    <div class="container mb-48">
      <AccountWidget />
      <div class="bg-gray rounded-t-md shadow relative z-50 mt-2 py-1 pb-4 sm:pb-8 rounded-b-md">
        <div class="text-center relative">
          <a
            class="absolute top-0 left-0 ml-6 mt-1 hover-animate cursor-pointer"
            @click="goToNewOrder"
          >
            <BackIcon />
          </a>
          <h2 class="mt-5 text-sm md:text-xl lg:text-2xl font-semibold uppercase text-primary mb-6 ml-14 mr-14 leading-snug">
            {{ $t('thankYou.heading') }}
          </h2>
        </div>
        <div class="border-t border-purple-gray px-4 sm:px-8 lg:px-16 py-6 w-full text-sm sm:text-base">
          <div class="mb-6">
            <div class="flex justify-center mb-6">
              <BoxIcon class="my-2" />
            </div>
            <div class="flex items-center flex-col text-center">
              <h2 class="font-semibold text-primary text-xl sm:text-2xl mx-3">
                {{ $t('thankYou.info') }}
              </h2>
              <p class="font-semibold text-black-display text-base sm:text-lg w-3/4 md:w-2/3 my-3 leading-snug">
                {{ $t('thankYou.info2') }}
              </p>
            </div>
          </div>
          <div class="flex justify-center flex-wrap lg:flex-no-wrap flex-col sm:flex-row">
            <button
              class="btn mx-3 sm:mx-0 btn-outline mt-3 sm:mt-5 h-14 px-4 md:px-10 my-3 md:mr-8 flex items-center justify-center"
              type="button"
              @click="triggerLogout"
            >
              {{ $t('thankYou.logout') }}
            </button>
            <button
              class="btn mx-3 sm:mx-0 mt-3 sm:mt-5 h-14 px-4 md:px-10 my-3 lg:mr-8 flex items-center justify-center"
              type="button"
              @click="goToNewOrder"
            >
              {{ $t('thankYou.newOrder') }}
            </button>
            <a
              target="_blank"
              :href="pdfUrl"
              class="btn mx-3 sm:mx-0 btn-gray mt-3 sm:mt-5 h-14 px-4 md:pl-10 md:pr-8 my-3 flex items-center justify-center"
            >
              {{ $t('thankYou.download') }} <PdfIcon class="ml-2 md:ml-4" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import AccountWidget from '@/components/AccountWidget';
import BackIcon from '@/assets/icons/back.svg';
import BoxIcon from '@/assets/icons/box.svg';
import PdfIcon from '@/assets/icons/pdf.svg';
import { LOGIN, START } from '@/router/routes.names';

export default {
  name: 'ThankYou',
  components: {
    AccountWidget,
    BackIcon,
    BoxIcon,
    PdfIcon,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('order', ['response']),
    pdfUrl() {
      return this.response ? this.response.pdf_url : '';
    },
  },
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('order', ['resetOrder']),
    async triggerLogout() {
      await this.logout();
      this.$router.push({ name: LOGIN });
    },
    async goToNewOrder() {
      await this.resetOrder();
      this.$router.push({ name: START });
    },
  },
};
</script>
